import { Fragment, useState, useEffect } from "react";
import NewTask from "./components/AddTask/NewTask";
import Tasks from "./components/ShowTasks/Tasks";
import useHttp from "./hooks/use-http";
import "./App.css";

function App() {
  const [tasks, setTasks] = useState([]);
  const { isLoading, error, sendRequest: fetchTasks } = useHttp();

  useEffect(() => {
    const verwerkOpgehaaldeTaken = (tasksArr) => {
      console.table(tasksArr);
      setTasks(tasksArr);
    };

    // De parameters van sendRequest (fetchTasks is de alias voor sendRequest) zijn: requestConfig, fncResponseData
    fetchTasks(
      {
        url: "https://www.marchouben.nl/php/taken-get.php",
      },
      verwerkOpgehaaldeTaken // pointer to the function
    );
  }, [fetchTasks]);

  const taskAddHandler = (task) => {
    console.log(task);
    setTasks((prevTasks) => prevTasks.concat(task));
  };

  return (
    <Fragment>
      <NewTask onAddTask={taskAddHandler} />
      <Tasks
        taken={tasks}
        loading={isLoading}
        error={error}
        onFetch={fetchTasks}
      />
    </Fragment>
  );
}

export default App;